const tileLayers = [
  {
    url:
      "https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png",
    options: {
      attribution:
        '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> | Map tiles by Carto',
      maxZoom: 11,
    },
  },
];

export default tileLayers;
